import React, { useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    emailid: "",
    mobile: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // 🔥 Save to Firestore
      await addDoc(collection(db, "contacts"), {
        name: formData.name,
        emailid: formData.emailid,
        mobile: formData.mobile,
        createdAt: serverTimestamp(),
      });

      alert("Application submitted successfully!");

      // Reset form
      setFormData({
        name: "",
        emailid: "",
        mobile: "",
      });

    } catch (error) {
      console.error(error);
      alert("Submission failed");
    }
  };

  return (
    <div className="card p-1">
      <h5 className="text-center mt-2">
        <b style={{ color: "#e4a629" }}>Book a Consultation</b>
      </h5>

      <center>
        <form onSubmit={handleSubmit}>
          <div className="row me-4">

            {/* Name */}
            <div className="col-md-4 mt-2">
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Full Name*"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            {/* Mobile */}
            <div className="col-md-3 mt-2">
              <input
                type="tel"
                name="mobile"
                className="form-control"
                placeholder="Mobile Number*"
                pattern="[0-9]{10}"
                maxLength="10"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>

            {/* Email */}
            <div className="col-md-3 mt-2">
              <input
                type="email"
                name="emailid"
                className="form-control"
                placeholder="Email Id"
                value={formData.emailid}
                onChange={handleChange}
              />
            </div>

            {/* Submit */}
            <div className="col-md-2 mt-2">
              <button className="btn btn-warning w-100" type="submit">
                Submit
              </button>
            </div>

          </div>
        </form>
        <br/>
      </center>
    </div>
  );
}

export default ContactForm;